import { Grid, Heading, Image, Text } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import AddressResetPage from '../addressReset'
import { Divider } from '../styles'
import { DetailsHeader, StyledBookingDetails } from './styles'
import PaymentOverviewPage from '../paymentoverview'
import { PropsBookInformationTemplate, PropsInformationTemplate } from './props'

const InformationTemplate = ({
    postText,
    preText,
}: PropsInformationTemplate) => (
    <Text primary>
        {preText}: <Text bold>{postText}</Text>
    </Text>
)

const BookingInformationTemplate = ({
    goalName,
    icon,
    informations,
    serviceLength,
}: PropsBookInformationTemplate): ReactElement => {
    const header = (
        <DetailsHeader>
            <Grid>
                <Heading bold primary size={2}>
                    {goalName}
                </Heading>
                <Heading level={3} primary>
                    {serviceLength}
                </Heading>
            </Grid>
            <Image src={icon} />
        </DetailsHeader>
    )

    const bookInformations = (
        <Grid>
            {informations.map((info, key) => (
                <InformationTemplate
                    key={key}
                    preText={info.preText}
                    postText={info.postText}
                />
            ))}
        </Grid>
    )

    return (
        <StyledBookingDetails>
            <Grid gap={16}>
                {header}
                {bookInformations}
                <AddressResetPage />
                <Divider />
                <PaymentOverviewPage />
            </Grid>
        </StyledBookingDetails>
    )
}

export default BookingInformationTemplate
